import { render, staticRenderFns } from "./failedJobsLaunched.vue?vue&type=template&id=33708970&scoped=true&"
import script from "./failedJobsLaunched.vue?vue&type=script&lang=js&"
export * from "./failedJobsLaunched.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33708970",
  null
  
)

export default component.exports